import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import * as Styled from './styles';
import AlignmentButton from './AlignmentButton';
import handleKeyPress from '../../common/handleKeyPress';

const Modal = ({ onClick }) => (
    <Styled.AlignmentModal>
        <AlignmentButton icon="format_align_left" align="left" label="Left Align" updateAlignment={onClick} />
        <AlignmentButton icon="format_align_center" align="center" label="Center Align" updateAlignment={onClick} />
        <AlignmentButton icon="format_align_right" align="right" label="Right Align" updateAlignment={onClick} />
        <AlignmentButton icon="format_align_justify" align="justify" label="Justify Align" updateAlignment={onClick} />
    </Styled.AlignmentModal>
);

Modal.propTypes = {
    onClick: PropTypes.func.isRequired,
};

const Alignment = ({ updateAlignment, currentAlignment }) => {
    const [showModal, setShowModal] = useState(false);
    const toggleModal = () => {
        setShowModal(!showModal);
    };

    const onClick = (align) => {
        updateAlignment('align', align);
        setShowModal(false);
    };

    return (
        <>
            <Styled.AlignmentButton onClick={toggleModal} onKeyDown={(e) => handleKeyPress(e, toggleModal)}>
                <i className="material-icons" data-tip data-for="textAlign" style={{ fontSize: 18 }}>
                    {`format_align_${currentAlignment}`}
                </i>
                <i className="material-icons" style={{ fontSize: 14 }}>
                    arrow_drop_down
                </i>
                {showModal && <Modal onClick={onClick} />}
            </Styled.AlignmentButton>
            <ReactTooltip id="textAlign" place="top" effect="solid">
                <span style={{ fontWeight: 'bold' }}>Text Align</span>
            </ReactTooltip>
        </>
    );
};

Alignment.propTypes = {
    updateAlignment: PropTypes.func.isRequired,
    currentAlignment: PropTypes.string.isRequired,
};

export default Alignment;
